import { createSlice } from '@reduxjs/toolkit'
import { BonusState } from '../../models/bonus.interface'

const initialState: BonusState = {
  totalAvailable: 0,
  totalBonus: 0,
  transection: [],
  hasBonus: false,
  dealDate: '',
}

export const bonusSlice = createSlice({
  name: 'bonus',
  initialState,
  reducers: {
    setTotalAvailable: (state, action) => {
      const { totalAvailable, totalBonus, transection, hasBonus, dealDate } = action.payload
      state.totalAvailable = totalAvailable
      state.totalBonus = totalBonus
      state.transection = transection
      state.hasBonus = hasBonus
      state.dealDate = dealDate
    },
    setStateKey: (state: any, action) => {
      const { key, value } = action.payload
      state[key] = value
    },
  },
}) //  end slice

export const { setStateKey, setTotalAvailable } = bonusSlice.actions
export const { name, actions, reducer } = bonusSlice
export default bonusSlice.reducer
